export default __webpack_public_path__ + "static/media/SD-SVDSSSK-img.ce5cbb27.png";